import script from "./CompanyToVetUrl.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyToVetUrl.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__